export default __webpack_public_path__ + "static/media/25.db313a55.jpeg";